import { StyleSheet } from 'react-native';
import { themes } from 'src/theme/theme';

export const styles = StyleSheet.create({
  container: {
    flexGrow: 1,
    backgroundColor: themes.light.white[1],
  },
  cardContainer: {
    backgroundColor: themes.light.gray_blue[7],
    padding: 16,
    gap: 12,
    flex: 1,
  },
  bottomContainer: {
    marginTop: 'auto', // Push it to the bottom of the cardContainer
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between', // Space between buttons
    gap: 8,
    width: '100%',
    padding: 16,
  },
  buttonWrapper1: {
    flex: 1, // Allow it to grow
    maxWidth: '33%', // Restrict to 33% width
  },
  buttonWrapper2: {
    flex: 1, // Allow it to grow
    maxWidth: '67%', // Restrict to 67% width
  },
});
